import { METRIC_TARGETS_VALUES, PLACEMENT_COLUMNS } from './metricTypes';

export const BASE_COLUMNS = ['allocation', 'cogs', 'profit', 'margin'];

export const PLACEMENT_BASE_COLUMNS = [...BASE_COLUMNS, ...PLACEMENT_COLUMNS];

export const COLUMNS_VALUES = [
  ...METRIC_TARGETS_VALUES,
  ...METRIC_TARGETS_VALUES.map((t) => `${t}_cpx`),
  ...METRIC_TARGETS_VALUES.map((t) => `${t}_fpx`),
  ...METRIC_TARGETS_VALUES.map((t) => `${t}_ppx`),
  ...METRIC_TARGETS_VALUES.map((t) => `${t}_allocation`),
  ...METRIC_TARGETS_VALUES.map((t) => `${t}_cogs`),
  ...METRIC_TARGETS_VALUES.map((t) => `${t}_profit`),
  ...METRIC_TARGETS_VALUES.map((t) => `${t}_margin`),
  ...BASE_COLUMNS,
];

export const INTERNAL_COLUMNS = [
  'count',
  'allocation',
  'cogs',
  'profit',
  'margin',
  'metric_value',
  'metric_allocation',
  'metric_cogs',
  'metric_cpx',
  'metric_fpx',
  'metric_ppx',
  'metric_margin',
  'metric_profit',
];
export const EXTERNAL_COLUMNS = ['_all_'];

export const SUMMARY_COLUMNS_SUBTYPES = [
  'value',
  'allocation',
  'cogs',
  'cpx',
  'fpx',
  'ppx',
  'margin',
  'profit',
];
export const SUMMARY_COLUMNS = [
  'count',
  'allocation',
  'cogs',
  'profit',
  'margin',
  ...SUMMARY_COLUMNS_SUBTYPES.map((item) => `metric_${item}`),
];
